export default {
  namespaced: true,
  state: () => ({
    returnPrice: 0,
    exchangePrice: 0,
    isPayWithMpos: false,
    isPaying: false
  }),
  getters: {
    getReturnPrice: state => state.returnPrice,
    getExchangePrice: state => state.exchangePrice,
    getIsPayWithMpos: state => state.isPayWithMpos,
    getIsPaying: state => state.isPaying,
  },
  mutations: {
    setReturnPrice(state, payload) {
      state.returnPrice = payload
    },
    setExchangePrice(state, payload) {
      state.exchangePrice = payload
    },
    setIsPayWithMpos(state, payload) {
      state.isPayWithMpos = payload
    },
    setIsPaying(state, payload) {
      state.isPaying = payload
    },
  },
};
